import styles from "./index.css";
import Link from "next/link";

const NavMenuLink = ({ title, subTitle, link, image, external }) => {
  return (
    <>
      {external && (
        <a href={link} target="_blank" className="nav-menu-item__link">
          {image && <img src={image} alt="logo" />}
          <span className="nav-menu-item__link-name">
            <span className={`__title ${subTitle ? "bold" : ""}`}>{title}</span>
            {subTitle && <span className="__sub-title">{subTitle}</span>}
          </span>
        </a>
      )}
      {!external && (
        <Link href={link} passHref>
          <a className="nav-menu-item__link">
            {image && <img src={image} alt="logo" />}
            <span className="nav-menu-item__link-name">
              <span className={`__title ${subTitle ? "bold" : ""}`}>
                {title}
              </span>
              {subTitle && <span className="__sub-title">{subTitle}</span>}
            </span>
          </a>
        </Link>
      )}
    </>
  );
};

const NavMenuItem = ({ title, links }) => {
  return (
    <div className="nav-menu-item">
      <p className="nav-menu-item__title">{title}</p>
      <div className="nav-menu-item__link-list">
        {links.map((link, index) => (
          <NavMenuLink key={`${link.title}-${index}`} {...link} />
        ))}
      </div>
    </div>
  );
};

const NavMenu = ({ title, menuList }) => {
  return (
    <>
      <div className="nav-menu">
        <div className="menu-title">
          <p>{title}</p>
        </div>
        <div className="menu-list">
          {menuList.map((menu, index) => (
            <NavMenuItem {...menu} key={`${title}-${index}`} />
          ))}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default NavMenu;
